module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct1p",
    attrs: {
      "id": "p0025-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_18",
      "id": "sn_18"
    }
  }, [_vm._v("DAY 18")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_18"
    }
  }, [_vm._v("LIFE IN THE ARK—AND YOU ARE THERE!")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("For forty days the flood kept coming on the earth. The waters flooded the earth for a hundred and fifty days.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 7:17, 24")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0025-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("t lasted a little longer than a year, that multisensory experience on steroids. Yes, we’re talking about Noah’s extraordinary time aboard the ark.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sights: Parrots, peacocks, pandas, polar bears.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sounds: Caws, growls, roars, trumpetings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Touch: Puppies, porcupines, kittens, snakes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Smells: Unhappy skunks. And the stable floors . . .")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tastes: With smells that intense, who could really taste food?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God calls. We obey, and it’s not always a luxury cruise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God had told Noah to bring onboard the ark “two of all living creatures, male and female” (Genesis 6:19). The future of the animal world was, literally, riding with Noah! Noah could at least know the satisfaction of obeying God. The rest was up to the Almighty.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And maybe that solid sense of contentment that comes with obeying God made the sounds and smells very, very unimportant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx3"
  }, [_vm._v("WHATEVER THE SURROUNDINGS, BEING RIGHT WHERE GOD WANTS US TO BE IS BETTER THAN BEING ANYWHERE ELSE.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3d78e6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter21.vue
// module id = 123
// module chunks = 0